<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        title="パスワード変更"
      />
      <div class="boss-table-2">
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">
            旧パスワード
          </div>
          <div class="boss-table-2-item boss-table-2-item-body">
            <input
              v-model="currentPassword"
              class="boss-input boss-input-fill"
              type="password"
              data-test="current-password"
            >
          </div>
        </div>
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">
            新パスワード
          </div>
          <div class="boss-table-2-item boss-table-2-item-body">
            <input
              v-model="newPassword"
              :class="{ 'is-invalid-input': isInvalidPassword || isSameCurrentAndNewPassword }"
              class="boss-input boss-input-fill"
              type="password"
              data-test="new-password"
            >
            <span
              v-if="isInvalidPassword"
              class="form-error is-visible margin-0"
              data-test="new-password-validation"
            >半角英数混在8文字以上20文字以内で入力してください。</span>
            <span
              v-if="isSameCurrentAndNewPassword"
              class="form-error is-visible margin-0"
              data-test="is-same-current-and-new-password"
            >現在のパスワードと異なるものを入力してください。</span>
          </div>
        </div>
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">
            新パスワード (確認用)
          </div>
          <div class="boss-table-2-item boss-table-2-item-body">
            <input
              v-model="confirmNewPassword"
              :class="{ 'is-invalid-input': isDifferentNewPassword }"
              class="boss-input boss-input-fill"
              type="password"
              data-test="confirm-new-password"
            >
            <span
              v-if="isDifferentNewPassword"
              class="form-error is-visible margin-0"
              data-test="is-same-new-password-confirm"
            >新パスワードと新パスワード(確認用)が一致しません。</span>
          </div>
        </div>
      </div>
      <div class="boss-button-container">
        <button
          :disabled="isDisable"
          class="boss-button-default pega-button"
          data-test="change-password-button"
          @click="changePassword"
        >
          パスワードを変更する
        </button>
      </div>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import _ from 'lodash'

export default {
  components: {
    SettingHeader
  },
  data () {
    return {
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    }
  },
  computed: {
    isInvalidPassword () {
      // 半角英数混在8文字以上20文字以内のチェック（空の場合は入力チェックをしない）
      return !_.isEmpty(this.newPassword) && !(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,20}$/i).test(this.newPassword)
    },
    isDifferentNewPassword () {
      return !_.isEmpty(this.confirmNewPassword) && this.newPassword !== this.confirmNewPassword
    },
    isSameCurrentAndNewPassword () {
      return !_.isEmpty(this.currentPassword) && this.currentPassword === this.newPassword
    },
    isDisable () {
      return _.isEmpty(this.currentPassword) || _.isEmpty(this.newPassword) || _.isEmpty(this.confirmNewPassword) || this.isInvalidPassword || this.isDifferentNewPassword || this.isSameCurrentAndNewPassword
    }
  },
  methods: {
    changePassword () {
      this.$http.secured.put('/settings/change_password', {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      }).then(
        response => {
          this.$toasted.global.success({ message: 'パスワードを変更しました。' })
        }
      )
    }
  }
}
</script>
